import type {
  TWellCorrelationSerializedInternalState,
  WellCorrelationWidgetEntity,
} from '../../../pages/dashboard/features/well-correlation-widget/WellCorrelationWidget.entity';

export function serializeWellCorrelationTemplate(widget: WellCorrelationWidgetEntity) {
  const internalState: TWellCorrelationSerializedInternalState = {
    wellId: null,
    stateParams: widget.stateParams,
  };

  return {
    uuid: widget.uuid,
    type: widget.type,
    groupId: widget.groupId,
    size: {
      w: widget.size.w,
      h: widget.size.h,
    },
    position: {
      x: widget.position.x,
      y: widget.position.y,
    },
    internalState,
  };
}
